export default __webpack_public_path__ + "static/media/staigeBackgroundOrange.e202b6cc.png";